'use strict';

var React = require('react');

var SvgThemeStoreMajor = function SvgThemeStoreMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 0a1.5 1.5 0 0 0-1.5 1.5v4a1.5 1.5 0 0 0 1.5 1.5h1.5v11.5a1.5 1.5 0 0 0 1.5 1.5h3.5a1 1 0 1 0 0-2h-3v-11h1.5a1.5 1.5 0 0 0 1.5-1.5v-.5h7a1 1 0 1 0 2 0v-.5a1.5 1.5 0 0 0-1.5-1.5h-7.5v-1.5a1.5 1.5 0 0 0-1.5-1.5h-5zm.5 2v3h4v-3h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 8a1 1 0 0 0-1 1v5a1 1 0 0 0 .293.707l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0 0-1.414l-5-5a1 1 0 0 0-.707-.293h-5zm4 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }));
};

exports.SvgThemeStoreMajor = SvgThemeStoreMajor;
